import { render, staticRenderFns } from "./CdKeyView.vue?vue&type=template&id=22b0622a&scoped=true"
import script from "./CdKeyView.vue?vue&type=script&lang=js"
export * from "./CdKeyView.vue?vue&type=script&lang=js"
import style0 from "./CdKeyView.vue?vue&type=style&index=0&id=22b0622a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b0622a",
  null
  
)

export default component.exports